import { EVENTS } from "../../../js/constants";

class Header {
  /**
   * @param {HTMLElement} element - Header element
   */
  constructor(element) {
    this.element = element;

    this._setCustomProperty = this._setCustomProperty.bind(this);

    this._bind();
  }

  /**
   * binds event listener
   */
  _bind() {
    window.addEventListener(EVENTS.RESIZED, this._setCustomProperty);
  }

  /**
   * defines a css custom property that is getting used for max-width in dropdown menu.
   *
   * in "embedded enviroments" like miyagi or drupal with backoffice ui elements,
   * there are problems with the vw unit that can't be fixed by only using css.
   *
   * @private
   */
  _setCustomProperty() {
    this.element.style.setProperty(
      "--Header-width",
      `${this.element.offsetWidth}px`
    );
  }
}

export default Header;
